(() => {
  const mobileCartQuery = window.matchMedia("(max-width: 989px)");

  customElements.whenDefined("hdt-cart-drawer").then(() => {
    const CartDrawer = customElements.get("hdt-cart-drawer");
    if (!CartDrawer || CartDrawer.prototype.swResponsiveDropdown) return;
    const Drawer = Object.getPrototypeOf(CartDrawer.prototype);
    const desktopOpenAnimation = Drawer.animateDialogOpen;
    const desktopCloseAnimation = Drawer.animateDialogClose;
    const closeDialog = Drawer.close;

    const resetDialogAnimation = (cartDrawer) => {
      const dialog = cartDrawer?.dialog;

      if (!dialog) return;

      dialog.getAnimations().forEach((animation) => animation.cancel());
      dialog.style.removeProperty("opacity");
      dialog.style.removeProperty("clip-path");
      dialog.style.removeProperty("transform");
      dialog.style.removeProperty("visibility");
    };

    Object.defineProperty(CartDrawer.prototype, "swResponsiveDropdown", {
      configurable: false,
      value: true,
    });

    Object.defineProperty(CartDrawer.prototype, "show", {
      configurable: true,
      get() {
        const isMobileCart = mobileCartQuery.matches;

        resetDialogAnimation(this);
        this._swCartOpenedAsMobile = isMobileCart;
        this.transform = isMobileCart ? "top" : this.pos;
        this._openedAsModal = true;

        return isMobileCart ? this.dialog.show() : this.dialog.showModal();
      },
    });

    Object.defineProperty(CartDrawer.prototype, "animateDialogOpen", {
      configurable: true,
      value() {
        if (!this._swCartOpenedAsMobile) {
          return desktopOpenAnimation.call(this);
        }

        return this.dialog.animate(
          [
            { opacity: 0, clipPath: "inset(0 0 100% 0)" },
            { opacity: 1, clipPath: "inset(0 0 0 0)" },
          ],
          {
            duration: 240,
            easing: "cubic-bezier(0.22, 0.7, 0.2, 1)",
            fill: "both",
          },
        );
      },
    });

    Object.defineProperty(CartDrawer.prototype, "animateDialogClose", {
      configurable: true,
      value() {
        if (!this._swCartOpenedAsMobile) {
          return desktopCloseAnimation.call(this);
        }

        return this.dialog.animate(
          [
            { opacity: 1, clipPath: "inset(0 0 0 0)" },
            { opacity: 0, clipPath: "inset(0 0 100% 0)" },
          ],
          {
            duration: 180,
            easing: "ease-in",
            fill: "both",
          },
        );
      },
    });

    Object.defineProperty(CartDrawer.prototype, "close", {
      configurable: true,
      async value(immediate = false) {
        try {
          return await closeDialog.call(this, immediate);
        } finally {
          if (!this.dialog?.open) {
            resetDialogAnimation(this);
            this._swCartOpenedAsMobile = undefined;
          }
        }
      },
    });

    const getOpenCart = () => {
      const cartDrawer = document.querySelector("hdt-cart-drawer");
      return cartDrawer?.dialog?.open ? cartDrawer : null;
    };

    let breakpointSyncTimer;

    const syncOpenCartToBreakpoint = async () => {
      const cartDrawer = getOpenCart();

      if (!cartDrawer) return;

      // A breakpoint change can fire while the customer is already closing the
      // cart. Reopening during that close leaves a transparent modal and its
      // backdrop behind on iPadOS. Let the active close finish instead.
      if (cartDrawer.dialog.classList.contains("dialog-closing")) return;

      // If rotation happens during the opening animation, retry after it
      // settles. This keeps the drawer in the correct modal mode without
      // overlapping animations.
      if (cartDrawer.dialog.classList.contains("dialog-opening")) {
        window.clearTimeout(breakpointSyncTimer);
        breakpointSyncTimer = window.setTimeout(syncOpenCartToBreakpoint, 120);
        return;
      }

      await cartDrawer.close(true);
      await cartDrawer.open(true);
    };

    document.addEventListener(
      "click",
      (event) => {
        if (!mobileCartQuery.matches || !(event.target instanceof Element)) {
          return;
        }

        const headerAction = event.target.closest(
          "sw-navigation-header a, sw-navigation-header button, sw-navigation-header summary",
        );

        if (!headerAction || headerAction.closest('[aria-controls="CartDrawer"]')) {
          return;
        }

        getOpenCart()?.close(true);
      },
      true,
    );

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && mobileCartQuery.matches) {
        getOpenCart()?.close();
      }
    });

    mobileCartQuery.addEventListener("change", syncOpenCartToBreakpoint);
  });
})();
